import { Observable } from "rxjs";
import { UserRelationshipsApiModel } from "../../models/userRelationships";
import { IEnvironmentConfig } from "../../models/environmentConfig";
import { AppConfig } from "../../app.config";
import { BaseHttpService } from "./base.http.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class UserRelationshipService extends BaseHttpService {
    
    constructor(private http: HttpClient, private appConfig: AppConfig){
        super();
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }
    
    public getUserRelationships(): Observable<UserRelationshipsApiModel>{
        const url = `${this.envSettings.webApiUrl}user/current/relationships`;
        return this.http.get<UserRelationshipsApiModel>(url, {
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }
}